var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('audio',{ref:"audio",attrs:{"controls":"controls","hidden":"","src":_vm.sound}}),_c('audio',{ref:"audio2",attrs:{"controls":"controls","hidden":"","src":_vm.sound2}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }